import { FC } from "react";
import Container from "react-bootstrap/Container";
import Alert from "react-bootstrap/Alert";
import Table from "react-bootstrap/Table";
import { Navigate } from "react-router-dom";
import { useRouteParams } from "app/route/route";
import { deleteContactRoute, contactsRoute } from "app/route/Routes";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { useDeleteContactMutation, useContactQuery } from "app/api/graph/types";
import { contactGraphId } from "app/api/graph/helpers";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";
import { ConfirmDelete } from "app/component/form/ConfirmDelete";
import { formatISODateTime } from "app/util/format";

export const DeleteContactScreen: FC = () => {
    const { contactId } = useRouteParams(deleteContactRoute);
    const { data, loading, error } = useContactQuery({
        variables: { contactId: contactGraphId(contactId) },
    });
    const [deleteContact, { data: deleteData, loading: deleting, error: deleteError }] = useDeleteContactMutation({
        variables: { input: { id: contactGraphId(contactId) } },
    });
    const contact = data?.contact;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!contact) {
        return <ErrorScreen title="Error" message="Not found." />;
    }
    if (deleteData?.deleteContact) {
        return <Navigate to={contactsRoute.build({})} />;
    }

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={deleteContactRoute} />
                <h1>Delete contact</h1>
                {deleteError ? <Alert variant="danger">{deleteError.message}</Alert> : null}
                <p>Are you sure that you want to permanently delete this contact?</p>
                <Table responsive="sm">
                    <tbody>
                        <tr>
                            <th>Name</th>
                            <td>{contact.name ?? "-"}</td>
                        </tr>
                        <tr>
                            <th>Created by</th>
                            <td>{contact.createdByFullName ?? "-"}</td>
                        </tr>
                        <tr>
                            <th>Created at</th>
                            <td>{formatISODateTime(contact.createdAt)}</td>
                        </tr>
                    </tbody>
                </Table>
                <Alert variant="danger">
                    <p>
                        This will <strong>permanently</strong> delete the contact - which cannot be reversed.
                    </p>
                </Alert>
                <ConfirmDelete onConfirm={() => deleteContact()} deleting={deleting} />
            </Container>
        </NavigationScreen>
    );
};
